'use strict';

/**
 * checkoutAddressSuggestEvent event
 */
function checkoutAddressSuggestEvent() {
    var dataLayerAnalytics = {
        datalayerEvent: []
    };
    dataLayerAnalytics.datalayerEvent.push({ event_name: 'site_interaction', site_interaction: 'loqate:select loqate address:checkout shipping' });
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}
/**
 * checkoutEditLineItemEvent event
 * @param {Object} data - data
 */
function checkoutEditLineItemEvent(data) {
    var dataLayerAnalytics = {
        datalayerEvent: []
    };
    var product = data.product;
    var checkoutEditProductLineItemData = {};
    checkoutEditProductLineItemData.event_name = 'product_view';
    if (product.masterProductData) {
        checkoutEditProductLineItemData.product_style_id = product.masterProductData.ID;
        checkoutEditProductLineItemData.product_name = product.masterProductData.name;
    }

    if (product.allBadges !== null) {
        checkoutEditProductLineItemData.product_badge_name = product.allBadges;
    }

    if (product.variationAttributes) {
        var colorcodeVariationAttr = product.variationAttributes.find(variationAttribute => variationAttribute.attributeId === 'colorCode');
        if (colorcodeVariationAttr) {
            checkoutEditProductLineItemData.product_upc_color_name = colorcodeVariationAttr.displayValue;
            checkoutEditProductLineItemData.product_upc_color_code = colorcodeVariationAttr.colorcode;
        }
    }
    checkoutEditProductLineItemData.product_upc_id = product.id;
    if (product.size) {
        checkoutEditProductLineItemData.product_upc_size = product.size;
    }
    var prices = product.analyticaPriceData;
    checkoutEditProductLineItemData.product_price_msrp = prices.fullPrice ? prices.fullPrice.toString() : '';
    checkoutEditProductLineItemData.product_price_actual = prices.outOfDoorPrice ? prices.outOfDoorPrice.toString() : '';
    checkoutEditProductLineItemData.product_price_shortmark = prices.markdownPrice ? prices.markdownPrice.toString() : '';
    dataLayerAnalytics.datalayerEvent.push(checkoutEditProductLineItemData);
    $('body').trigger('datalayerEvent:view', dataLayerAnalytics);
}

/**
 * checkoutRemoveLineItemEvent event
 * @param {Object} data - data
 */
function checkoutRemoveLineItemEvent(data, errorCodes) {
    if (!data || !data.deletedPliAnalyticsData) return;
    var itemRemoved = data.deletedPliAnalyticsData;
    // Rename event_name to event_type
    itemRemoved.event_type = itemRemoved.event_name;
    delete itemRemoved.event_name;
    if (errorCodes) {
        itemRemoved.event_type+= ',error_serverside';
        itemRemoved.error_serverside = errorCodes;
    }
    var dataLayerAnalytics = {
        datalayerEvent: []
    };
    dataLayerAnalytics.datalayerEvent.push(itemRemoved);
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}

/**
 * checkout order summary expand/collapse
 */
function checkoutOrderSummaryToggle(toggleFlag) {
    var dataLayerAnalytics = {
        datalayerEvent: []
    };
    let accordionState;
    if (toggleFlag === 'true') {
        accordionState = 'checkout:sticky bag:collapse';
    } else {
        accordionState = 'checkout:sticky bag:expand';
    }
    dataLayerAnalytics.datalayerEvent.push({ event_type: 'site_interaction', site_interaction: accordionState });
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}

/**
 * checkout order summary expand/collapse
 */
function newShippingeddDates(data, respflag) {
    var dataLayerAnalytics = {
        datalayerEvent: []
    };

    var today = new Date();
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var monthName = months[today.getMonth()]; // getMonth() returns 0-based index
    var dayOfMonth = today.getDate();
    var year = today.getFullYear();
    var formattedTodayDate = monthName + ' ' + dayOfMonth + ' ' + year;

    var currentyear = new Date().getFullYear();
    var eddresponcedata = respflag ? data.order.shipping[0] : data.responseJSON.order.shipping[0];  /**reg user updateshippingmethodcall() fails scenario */
    var eddDate = eddresponcedata.applicableShippingMethods[0].estimatedArrivalDate + ' ' + currentyear;
    var onlypreorderitems = respflag ? data.order.hasAllPreOrderItems : data.responseJSON.order.hasAllPreOrderItems
    if (new Date(eddDate) >= new Date(formattedTodayDate)) {
        currentyear = new Date().getFullYear();
        eddDate = eddresponcedata.applicableShippingMethods[0].estimatedArrivalDate + ' ' + currentyear;
    } else {
        currentyear = currentyear + 1;
        eddDate = eddresponcedata.applicableShippingMethods[0].estimatedArrivalDate + ' ' + currentyear;
    }

    // var formattededdDate = data.order.shipping[0].applicableShippingMethods[0].estimatedArrivalDate + ' ' + currentyear;
    formattedTodayDate = new Date(formattedTodayDate);
    eddDate = new Date(eddDate);
    var formattededdDate = Math.ceil((eddDate - formattedTodayDate) / (1000 * 60 * 60 * 24));

    let eddtype = !onlypreorderitems ? eddresponcedata.selectedShippingMethod.eddType : 'none';
    let edddaysto_delivery = !onlypreorderitems ? formattededdDate : 'none';

    dataLayerAnalytics.datalayerEvent.push({ edd_type: eddtype, edd_days_to_delivery: edddaysto_delivery });
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}

/**
 * checkout shipping summary submit
 */
function checkoutShippingFormComplete(eventName) {
    var dataLayerAnalytics = {
        datalayerEvent: []
    };
 
    dataLayerAnalytics.datalayerEvent.push({ event_name: eventName });
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}

/**
 * checkoutAddnewAddressEvent event
 * @param {Object} errorCodes - errorCodes
 */
function checkoutAddnewAddressEvent(optMail, errorCodes) {
    var dataLayerAnalytics = {
        datalayerEvent: []
    };
    var addNewAddressObj = {};
    addNewAddressObj.event_name = 'checkout_shipping_method';
    if (optMail) {
        addNewAddressObj.event_name = 'checkout_shipping_method,email_signup_success';
        addNewAddressObj.email_signup_location = 'checkout shipping';
    }
    if (errorCodes && errorCodes.length > 0) {
        addNewAddressObj.event_name += ',error_serverside';
        addNewAddressObj.error_serverside = errorCodes;
    }
    dataLayerAnalytics.datalayerEvent.push(addNewAddressObj);
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}

/**
 * Checkout Suggestion Pop Up Modal event
 */
function checkoutSuggestionPopUpModal(eventName) {
    var dataLayerAnalytics = {
        datalayerEvent: []
    };
    var suggestionModalObj = {};
    suggestionModalObj.event_name = 'site_interaction';
    if (eventName === 'AppearSuggestionModal') {
        suggestionModalObj.site_interaction = 'address_validation:popup:impression';
    }
    if (eventName === 'EditSuggestionAddress') {
        suggestionModalObj.site_interaction = 'address_validation:popup:edit address';
    }
    if (eventName === 'CloseSuggestionModal') {
        suggestionModalObj.site_interaction = 'address_validation:popup:close';
    }
    if (eventName === 'Save&ContinueSuggestedAddress') {
        suggestionModalObj.site_interaction = 'address_validation:popup:continue_suggested address';
    }
    if (eventName === 'Save&ContinueEnteredAddress') {
        suggestionModalObj.site_interaction = 'address_validation:popup:continue_entered address';
    }
 
    dataLayerAnalytics.datalayerEvent.push(suggestionModalObj);
    $('body').trigger('datalayerEvent:link', dataLayerAnalytics);
}

module.exports = {
    checkoutAddressSuggestEvent: checkoutAddressSuggestEvent,
    checkoutEditLineItemEvent: checkoutEditLineItemEvent,
    checkoutRemoveLineItemEvent: checkoutRemoveLineItemEvent,
    checkoutAddnewAddressEvent: checkoutAddnewAddressEvent,
    checkoutShippingFormComplete: checkoutShippingFormComplete,
    checkoutOrderSummaryToggle: checkoutOrderSummaryToggle,
    checkoutSuggestionPopUpModal: checkoutSuggestionPopUpModal,
    newShippingeddDates: newShippingeddDates
};
